import { Injectable } from "@angular/core";
import {
    Flyer,
    ChildFlyer
} from "@shopliftr/common-js/admin";

import {
    Observable,
    BehaviorSubject
} from "rxjs";

/**
 * This service persists the state of the flyer needed for data entry management between component
 */
@Injectable({
    providedIn: "root"
})
export class FlyerStateService {

    private readonly _selectedFlyer$ = new BehaviorSubject<Flyer | ChildFlyer>(undefined);

    private readonly _selectedRootFlyer$ = new BehaviorSubject<Flyer>(undefined);

    get selectedFlyer$(): Observable<Flyer | ChildFlyer> {

        return this._selectedFlyer$.asObservable();
    }

    /**
     * The specific flyer in the root flyer's hierarchy currently being worked on
     *
     * This can either be the selectedRootFlyer or one of its children
     */
    get selectedFlyer(): Flyer | ChildFlyer {

        return this._selectedFlyer$.value;
    }

    /**
     *
     * The root flyer for the flyer currently being worked on
     */
    get selectedRootFlyer$(): Observable<Flyer> {

        return this._selectedRootFlyer$.asObservable();
    }

    /**
     *
     * The root flyer being worked on
     */
    get selectedRootFlyer(): Flyer {

        return this._selectedRootFlyer$.value;
    }

    /**
     * Update the selected flyer
     *
     * It must be either the selectedRootFlyer or one of its children or an error will be thrown.
     */
    updateSelectedFlyer(flyer: Flyer | ChildFlyer): void {

        if (this.selectedRootFlyer?.id !== flyer.id && !this.selectedRootFlyer?.childFlyerIds.includes(flyer.id)) {

            throw new Error(`Flyer ${flyer.id} is not part of selected root flyer ${this.selectedRootFlyer?.id}`);
        }
        this._selectedFlyer$.next(flyer);
    }

    /**
     * Clears the selected flyer
     */
    clearSelectedFlyer(): void {

        this._selectedFlyer$.next(undefined);
    }

    /**
     * Updates the selected root flyer
     * It will clear the selected flyer
     */
    updateSelectedRootFlyer(flyer: Flyer): void {

        this._selectedRootFlyer$.next(flyer);
        this.clearSelectedFlyer();
    }

    /**
     * Clears the selected root flyer
     * It will also clear the selected flyer
     */
    clearSelectedRootFlyer(): void {

        this._selectedRootFlyer$.next(undefined);
        this.clearSelectedFlyer();
    }

    reset(): void {

        this._selectedFlyer$.next(undefined);
        this._selectedRootFlyer$.next(undefined);
    }
}
